import { render } from "./CreateCompanyComponent.vue?vue&type=template&id=b61a0292"
import script from "./CreateCompanyComponent.vue?vue&type=script&lang=js"
export * from "./CreateCompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__